import React from 'react';
import textToHtmlAttribute from 'shared/lib/textToHtmlAttribute';
import { textPublicPropTypes } from 'shared/proptypes/ContentModule';

const ContentModuleViewHtml = ({ title, text }) => (
  <>
    {title && (<h2>{title}</h2>)}
    <div {...textToHtmlAttribute(text)} />
  </>
);

ContentModuleViewHtml.propTypes = textPublicPropTypes;

export default ContentModuleViewHtml;
